// extracted by mini-css-extract-plugin
export var header = "_uj-1";
export var maskBottom = "_uj-6";
export var maskMiddle = "_uj-7";
export var maskTop = "_uj-5";
export var root = "_uj-0";
export var scrollDownButton = "_uj-3";
export var scrollDownButtonHidden = "_uj-4";
export var viewport = "_uj-2";